<p>upload-sub-videos-tab works!</p>
